import { render, staticRenderFns } from "./antarkankebaikanEdit.vue?vue&type=template&id=53dbfc6e&"
import script from "./antarkankebaikanEdit.vue?vue&type=script&lang=js&"
export * from "./antarkankebaikanEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports